import React from 'react';
import moment from 'moment';

import { useI18n } from 'i18n';
import { ITepEntryPass } from 'types/tep';
import { IInfoTableCell } from 'types/info-table';

export const useNotifyLeasesColumns = () => {
  const { fc } = useI18n();

  const getDateCell = (cell: IInfoTableCell<ITepEntryPass, string>) => (
    <>{cell.value ? moment(cell.value).format('DD/MM/YYYY') : '-'}</>
  );

  return [
    { header: fc('name'), accessorKey: 'name', width: 100, minWidth: 100 },
    { header: fc('IMEI'), accessorKey: 'device.uri', minWidth: 160 },
    { header: fc('company'), accessorKey: 'lease.company', minWidth: 120 },
    { header: fc('emails'), accessorKey: 'lease.email', minWidth: 120 },
    { header: fc('Vehicle Plate No'), accessorKey: 'lease.plateNumber', minWidth: 120 },
    { header: fc('TEP Start'), accessorKey: 'lease.startOn', cell: getDateCell, minWidth: 120 },
    { header: fc('TEP End'), accessorKey: 'lease.endOn', cell: getDateCell, minWidth: 120 },
  ];
};
